import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { PublicShell } from "../components/PublicShell";
import { ARTICLES } from "../data/articles";

export default function Articles() {
  useEffect(() => {
    document.title = "Articles — Benzodiazepine Recovery & Tapering | TaperPath";
    setMeta("description", "Plain-English, SEO-friendly articles on the benzodiazepine epidemic, fake benzos, tapering safely, withdrawal symptoms and finding recovery support across the UK & Ireland.");
    return () => { document.title = "TaperPath"; };
  }, []);

  return (
    <PublicShell>
      <section className="mx-auto max-w-7xl px-6 py-12 lg:py-16">
        <div className="max-w-2xl animate-fade-up">
          <span className="mb-4 inline-block rounded-full bg-[#8FB8DE]/25 px-4 py-1.5 text-sm font-medium text-[#2C4763]">Learn · Free to read</span>
          <h1 className="font-head text-4xl font-extrabold leading-tight text-[#2C363F] sm:text-5xl">Articles &amp; guides</h1>
          <p className="mt-4 text-lg leading-relaxed text-[#64748B]">Clear, compassionate, evidence-informed writing on benzodiazepines, tapering and recovery — no jargon, no judgement.</p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="articles-grid">
          {ARTICLES.map((a) => (
            <Link key={a.slug} to={`/articles/${a.slug}`} data-testid={`article-card-${a.slug}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-white shadow-sm transition-transform duration-300 hover:-translate-y-1">
              <div className="h-44 overflow-hidden">
                <img src={a.image} alt={a.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-3 text-xs font-medium text-muted-foreground">
                  <span className="rounded-full bg-[#4A7c59]/10 px-2.5 py-0.5 text-[#4A7c59]">{a.category}</span>
                  <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {a.readTime}</span>
                </div>
                <h2 className="mt-3 font-head text-lg font-semibold leading-snug text-[#2C363F]">{a.title}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{a.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#4A7c59]">Read article <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </PublicShell>
  );
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
